var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gantt-elastic__task-list-header",style:({
    ..._vm.root.style['task-list-header'],
    height: `${_vm.root.state.options.calendar.height}px`,
    'margin-bottom': `${_vm.root.state.options.calendar.gap}px`,
  })},_vm._l((_vm.root.getTaskListColumns),function(column){return _c('div',{key:column._id,staticClass:"gantt-elastic__task-list-header-column",style:({
      ..._vm.root.style['task-list-header-column'],
      ...column.style['task-list-header-column'],
      ..._vm.getStyle(column),
    })},[(column.expander)?_c('task-list-expander',{attrs:{"tasks":_vm.collapsible,"options":_vm.root.state.options.taskList.expander}}):_vm._e(),_c('div',{staticClass:"gantt-elastic__task-list-header-label",style:({
        ..._vm.root.style['task-list-header-label'],
        ...column.style['task-list-header-label'],
      }),attrs:{"column":column},on:{"mouseup":_vm.resizerMouseUp}},[_vm._v(" "+_vm._s(column.label)+" ")]),_c('div',{staticClass:"gantt-elastic__task-list-header-resizer-wrapper",style:({
        ..._vm.root.style['task-list-header-resizer-wrapper'],
        ...column.style['task-list-header-resizer-wrapper'],
      }),attrs:{"column":column},on:{"mousedown":function($event){return _vm.resizerMouseDown($event, column)}}},[_c('div',{staticClass:"gantt-elastic__task-list-header-resizer",style:({
          ..._vm.root.style['task-list-header-resizer'],
          ...column.style['task-list-header-resizer'],
        })},[_c('div',{staticClass:"gantt-elastic__task-list-header-resizer-dot",style:({
            ..._vm.root.style['task-list-header-resizer-dot'],
            ...column.style['task-list-header-resizer-dot'],
          })}),_c('div',{staticClass:"gantt-elastic__task-list-header-resizer-dot",style:({
            ..._vm.root.style['task-list-header-resizer-dot'],
            ...column.style['task-list-header-resizer-dot'],
          })}),_c('div',{staticClass:"gantt-elastic__task-list-header-resizer-dot",style:({
            ..._vm.root.style['task-list-header-resizer-dot'],
            ...column.style['task-list-header-resizer-dot'],
          })})])])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }